<template>
  <app-page title="Login">
    <div id="firebaseui-auth-container"></div>
  </app-page>
</template>

<script>
import { startLoginUI } from "@/helpers/firebase";

export default {
  name: "login",
  mounted: function() {
    startLoginUI();
  }
};
</script>

<style></style>
